import { RegularExpression } from './interfaces';

export const required = (v: string | number): boolean => {
  return !!v;
};

export const email = (v: string): boolean => {
  if (!v) return true;
  const re = /^(([^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+(\.[^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return (re as RegularExpression).test(v);
};

export const graterThan = (v: number, limit = 0): boolean => {
  return v > limit;
};

export const number = (v: string): boolean => {
  if (!v) return true;
  const regExp = /^[+-]?\d+(\.\d+)?$/;
  return regExp.test(v);
};
